import React, { useState, useEffect, useContext } from 'react'
import { useSelector, useDispatch } from 'react-redux'
import { createUseStyles } from 'react-jss'
import axios from 'axios'
import { useToasts } from 'react-toast-notifications'

import * as quotationActions from '../../actions/quotation'
import * as ratesActions from '../../actions/rates'
import * as modelsActions from '../../actions/models'

import * as widgetRules from '../rules/widget'

import Context from '../Context'

import { v4 as uuidv4 } from 'uuid'
import moment from 'moment'
import _ from 'lodash'

import setHours from 'date-fns/setHours'
import setMinutes from 'date-fns/setMinutes'
import subDays from 'date-fns/subDays'
import addDays from 'date-fns/addDays'

import BookingTitleBar from '../ui/Homepage/BookingWidget/BookingTitleBar'
import BookingSplitTitleBar from '../ui/Homepage/BookingWidget/BookingSplitTitleBar'
import BookingWidget from '../ui/Homepage/BookingWidget/BookingWidget'
import BookingColumn from '../ui/Homepage/BookingWidget/BookingColumn'
import BookingWidgetTitle from '../ui/Homepage/BookingWidget/BookingWidgetTitle'
import BookingSeachButton from '../ui/Homepage/BookingWidget/BookingSearchButton'
import DateTimeSelect from '../ui/Homepage/BookingWidget/DateTimeSelect'
import AgeSelect from '../ui/Homepage/BookingWidget/AgeSelect'
import LocationSelect from '../ui/Homepage/BookingWidget/LocationSelect'
import BookingFormInput from '../ui/Homepage/BookingWidget/BookingFormInput'
import BookingPickupAccordion from '../ui/Homepage/BookingWidget/BookingPickupAccordion'

const useStyles = createUseStyles(theme => ({
  label: {
    marginBottom: 10,
  },
  input: {
    paddingRight: 10,
    paddingLeft: 10,
    paddingTop: 8,
    paddingBottom: 8,
    fontSize: 14,
    border: 0,
  },
  button: {
    borderRadius: theme.borderRadius,
    backgroundColor: theme.colors.yellow,
    border: 0,
    color: theme.colors.marine,
    fontSize: 14,
    letterSpacing: '0.2px',
    lineHeight: 'normal',
    textAlign: 'center',
    display: 'inline-block',
    marginTop: 0,
    paddingRight: 22,
    paddingLeft: 22,
    paddingTop: 8,
    paddingBottom: 8,
    textDecoration: 'none',
    textTransform: 'uppercase',
    fontWeight: 'bold',
    transition: `background-color 250ms ${theme.animations.bezier}`,
    '&:hover': {
      backgroundColor: theme.colors.sunflower,
      borderBottom: 'transparent',
      cursor: 'pointer',
    },
  },
  authSection: {
    width: '100%',
    padding: '0 20px',
    boxSizing: 'border-box',
    maxWidth: '1480px',
    margin: '0 auto',
    display: 'flex',
    justifyContent: 'space-between',
    '@media (max-width: 900px)': {
      flexDirection: 'column',
      gap: '35px',
      justifyContent: 'flex-start',
    },
  },
  formContainer: {
    display: 'flex',
    alignItems: 'flex-end',
    gap: '20px',
    '@media (max-width: 400px)': {
      flexDirection: 'column',
      justifyContent: 'flex-start',
      alignItems: 'flex-start',
    },
  },
  centerondesktop: {
    textAlign: 'center',
    '@media (max-width: 900px)': {
      textAlign: 'left',
      paddingTop: 5,
    },
  },
}))

const Itinerary = () => {
  const handleLoginSubmit = e => {
    e.preventDefault()

    const params = new FormData()
    params.append('username', e.target.username.value)
    params.append('password', e.target.password.value)

    axios
      .post('/api/partner-login', params)
      .then(function({ data }) {
        if (data.status !== true) {
          alert(data.message)
          return
        }
        localStorage.setItem('partner-token', data.token)
        location.reload()
      })
      .catch(function(error) {
        console.log(error)
      })
  }

  const classes = useStyles()
  const context = useContext(Context)
  const { addToast } = useToasts()
  const dispatch = useDispatch()
  const app = useSelector(state => ({ ...state.app }))
  const quotation = useSelector(state => ({ ...state.quotation }))
  const models = useSelector(state => ({ ...state.models }))
  const locations = useSelector(state => ({ ...state.models.locations }))
  const locales = useSelector(state => ({ ...state.models.locales }))
  const ages = useSelector(state => ({ ...state.models.ages }))
  const switchboards = useSelector(state => ({ ...state.models.switchboards }))
  const promocode = useSelector(state => ({ ...state.models.promocode }))
  const relocation = useSelector(state => ({ ...state.models.relocation }))

  const currentTrip = quotation.trips[quotation.trip]

  const [filterDate, setFilterDate] = useState()
  const [filterDateDropOff, setFilterDateDropOff] = useState()
  const [widgetSkin, setWidgetSkin] = useState({})
  const [pickupOptions, setPickupOptions] = useState([])
  const [dropoffOptions, setDropoffOptions] = useState([])
  const [itineraryLbls, setItineraryLbls] = useState({})
  const [pagesLbls, setPagesLbls] = useState({})
  const [pickupLocation, setPickupLocation] = useState([])
  const [dropoffLocation, setDropoffLocation] = useState([])
  const [locationsArr, setLocationsArr] = useState([])
  const [nzOptions, setNzOptions] = useState([])
  const [auOptions, setAuOptions] = useState([])
  const [driverAge, setDriverAge] = useState([])
  const [driveAgeOptions, setDriveAgeOptions] = useState([])
  const [promo, setPromo] = useState(currentTrip.promo)
  const [splitbooking, setSplitbooking] = useState(false)
  const [splitbookingToSouthNotAllowed, setSplitbookingToSouthNotAllowed] = useState(false)
  const [splitbookingToNorthNotAllowed, setSplitbookingToNorthNotAllowed] = useState(false)
  const [splitInit, setSplitInit] = useState(false)
  const [ferrybooking, setFerrybooking] = useState(false)
  const [promoChecked, setPromoChecked] = useState(false)
  const [relocationChecked, setRelocationChecked] = useState(false)
  const [iframe, setIframe] = useState(false)
  const [afterHourPickup, setAfterHourPickup] = useState(false)
  const [availabilityCheck, setAvailabilityCheck] = useState(false)

  const [pageLoaded, setPageLoaded] = useState(false)
  const [clickedSearchSplit, setClickedSearchSplit] = useState(false)
  const [clickedSearchFinal, setClickedSearchFinal] = useState(false)
  // const [blackVehicles, setBlackVehicles] = useState([])
  // const [restrictedVehicleLocations, setRestrictedVehicleLocations] = useState([])
  let today = new Date()
  let tomorrow = new Date()
  today = today.setDate(today.getDate() + 1)
  tomorrow = tomorrow.setDate(tomorrow.getDate() + 2)

  const [pickupDate, setPickupDate] = useState()
  const [pickupMinDate, setPickupMinDate] = useState(subDays(today, 1))

  const [dropoffDate, setDropoffDate] = useState()
  const [dropoffMinDate, setDropoffMinDate] = useState(subDays(tomorrow, 1))

  // const [pickupTime, setpickupTime] = useState(setHours(setMinutes(new Date(), 30), 9))
  // const[pickupTime, setpickupTime] = useState([])
  // const [dropoffTime, setdropoffTime] = useState(setHours(setMinutes(new Date(), 30), 20))

  // const [openingTime, setopeningTime] = useState([])

  const [globalOpeningTime, setglobalOpeningTime] = useState({})
  const [globalClosingTime, setglobalClosingTime] = useState({})
  const [globalHours, setglobalHours] = useState([])

  const [globalDropOffOpeningTime, setglobalDropOffOpeningTime] = useState({})
  const [globalDropOffClosingTime, setglobalDropOffClosingTime] = useState({})
  const [globalDropOffHours, setglobalDropOffHours] = useState([])

  const [partner, setPartner] = useState({})
  const defaultCountry = context.env['country']

  const [refreshTrip, setRefreshTrip] = useState(quotation.trip) // Used to manage render refresh of Components
  const [forceRefresh, setForceRefresh] = useState(false) // Used to manage render refresh of Components

  const [searchMode, setSearchMode] = useState(false)
  const [searchParams, setSearchParams] = useState(new URLSearchParams(''))

  const arr_path = location.pathname.toLowerCase().split('/')
  let mode =
    quotation.mode != 'default'
      ? quotation.mode
      : _.get(arr_path, '1', '') == 'experience'
      ? _.get(arr_path, '2', 'default')
      : 'default'

  let searchButtonClicked = false

  const [onload, setOnload] = useState(false)
  useEffect(() => {
    try {
      if (
        pickupLocation &&
        pickupLocation[0] &&
        pickupLocation[0].value &&
        locations &&
        onload === false
      ) {
        selectHandleChange(
          { value: pickupLocation[0].value, label: pickupLocation[0].label },
          { action: 'select-option', option: undefined, name: 'formPickupLocation' },
        )
        setOnload(true)
      }
    } catch (err) {
      setOnload(false)
    }
  }, [pickupLocation, locations, onload])

  useEffect(() => {
    const urlArr = _.split(decodeURI(location.href), '?', 2)
    const sParams = new URLSearchParams(urlArr.length > 1 ? urlArr[1].toString() : '')
    if (sParams.has('promo')) {
      setPromo(sParams.get('promo'))
    }

    if (location.pathname.indexOf('/bookings/') == -1) {
      if (_.isEmpty(currentTrip.car)) {
        // - only dispatch if car wasn't selected.
        // this will execute on first load
        dispatch(modelsActions.getCMSPartners())
        dispatch(modelsActions.getCMSLocations())
        dispatch(modelsActions.getCMSVehicles())
        dispatch(modelsActions.getCMSLocales())
        dispatch(modelsActions.getCMSRegions())
        dispatch(modelsActions.getCMSAges())
        dispatch(modelsActions.getCMSSwitchboards())
        dispatch(quotationActions.setQuotation({ data: { ..._.set(quotation, 'mode', mode) } }))
      }
    } else {
      setupLocations()
      setupDateTime()
    }
    setPageLoaded(true)
  }, [])

  useEffect(() => {
    if (searchMode) {
      onSearch()
    }
  }, [searchMode])

  useEffect(() => {
    setPartner(_.find(models.partners, { mode }))
    setWidgetSkin({ ...widgetRules.getSkin(quotation.trip, quotation, models, context, mode) })
  }, [models.partners])

  useEffect(() => {
    setupLocations()
  }, [locations, partner])

  useEffect(() => {
    if (
      Object.keys(locales).length !== 0 &&
      (Object.keys(itineraryLbls).length === 0 || Object.keys(pagesLbls).length === 0)
    ) {
      // Objects Empty check
      setItineraryLbls(locales.itinerary[0])
      setPagesLbls(locales.pages[0])
    } else {
      // Empty Locales Object
    }
  }, [locales])

  // useEffect(() => {
  //   if (
  //     Object.keys(ages).length !== 0 &&
  //     (driveAgeOptions.length < 1 || driveAgeOptions == undefined)
  //   ) {
  //     // Objects Empty check

  //     let optAge = []
  //     let optAgeSelected = []

  //     Object.keys(ages).forEach((key, index) => {
  //       optAge.push({ label: ages[key].label, value: ages[key].value })
  //       if (ages[key].selected) {
  //         optAgeSelected.push({ label: ages[key].label, value: ages[key].value })
  //       }
  //     })

  //     setDriverAge(optAgeSelected)
  //     setDriveAgeOptions(optAge)
  //   } else {
  //     // Empty Locales Object
  //   }
  // }, [ages])

  useEffect(() => {
    if (
      Object.keys(ages).length !== 0 &&
      (driveAgeOptions.length < 1 || driveAgeOptions == undefined)
    ) {
      // Objects Empty check
      if (typeof currentTrip.dob === 'string' && currentTrip.dob !== '') {
        let optAge = []
        let optAgeSelected = []

        Object.keys(ages).forEach((key, index) => {
          optAge.push({ label: ages[key].label, value: ages[key].value })
          if (ages[key].value === currentTrip.dob) {
            optAgeSelected.push({ label: ages[key].label, value: ages[key].value })
          }
        })
        setDriverAge(optAgeSelected)
        setDriveAgeOptions(optAge)
      } else {
        let optAge = []
        let optAgeSelected = []

        Object.keys(ages).forEach((key, index) => {
          optAge.push({ label: ages[key].label, value: ages[key].value })
          if (ages[key].selected) {
            optAgeSelected.push({ label: ages[key].label, value: ages[key].value })
          }
        })
        setDriverAge(optAgeSelected)
        setDriveAgeOptions(optAge)
      }
    } else {
      // Empty Locales Object
    }
  }, [ages])

  useEffect(() => {
    if (Object.keys(switchboards).length !== 0) {
      // Objects Empty check
      setSplitbooking(!!parseInt(switchboards.split_booking_active))
      setSplitbookingToSouthNotAllowed(
        !!parseInt(switchboards.split_booking_north_to_south_not_allowed),
      )
      setSplitbookingToNorthNotAllowed(
        !!parseInt(switchboards.split_booking_south_to_north_not_allowed),
      )
      setFerrybooking(!!parseInt(switchboards.ferry_booking_active))
    } else {
      // Empty Switchboards Object
    }
  }, [switchboards])

  useEffect(() => {
    if (pageLoaded) {
      if (Object.keys(promocode).length !== 0 && !promoChecked) {
        // Objects Empty check
        setPromoChecked(true)
      } else {
        // Empty Promocode Object
      }

      if (Object.keys(relocation).length !== 0) {
        // Objects Empty check
        setRelocationChecked(true)
      } else {
        // Empty Relocation Object
      }
    }
  }, [promocode, relocation])

  useEffect(() => {
    if (pageLoaded) {
      if (promoChecked) getRates()
      if (relocationChecked) getRates()
    }
  }, [promoChecked, relocationChecked])

  useEffect(() => {
    if (pageLoaded && relocationChecked) {
      getRates()
    }
    if (!availabilityCheck) {
      if (splitInit && quotation.trips[1].rates.default && quotation.trips[2].rates.default) {
        // Extra validation for Init Split Booking
        setAvailabilityCheck(true)
        checkAvailability()
      } else if (!splitInit && quotation.trips[quotation.trip].rates[mode]) {
        setAvailabilityCheck(true)
        checkAvailability()
      }
    }
  }, [quotation.trips[1].rates, quotation.trips[2].rates])

  useEffect(() => {
    // Refresh

    if (refreshTrip != quotation.trip) {
      setupLocations()
      setupDateTime()
      setRefreshTrip(quotation.trip)
    } else if (forceRefresh) {
      // Apply Code
      setForceRefresh(false)
    }
  }, [quotation.trip, forceRefresh])

  useEffect(() => {
    if (quotation.split) {
      // Splitbooking Date Selected Check
      switch (quotation.splitDateSelected) {
        case 0:
          if (quotation.trip == 1) {
            let info_message = 'Please select a Drop Off Date and Time for Trip 1 and Search.'
            addToast(info_message, {
              appearance: 'info',
              autoDismiss: true,
            })
          }
          break
        case 1:
          if (quotation.trip == 2) {
            let info_message = 'Please select a Pick Up Date and Time for Trip 2 and Search.'
            addToast(info_message, {
              appearance: 'info',
              autoDismiss: true,
            })
          }
          break
        case 2:
          // Continue Booking
          break
      }
    }
  }, [quotation.splitDateSelected])

  const setupLocations = () => {
    if (
      Object.keys(locations).length !== 0 &&
      Object.keys(itineraryLbls).length !== 0 &&
      (pickupOptions.length < 1 ||
        pickupOptions == undefined ||
        dropoffOptions.length < 1 ||
        dropoffOptions == undefined ||
        refreshTrip != quotation.trip ||
        forceRefresh)
    ) {
      // Object Empty check and Options Array Empty check
      // Set Location Options
      let optNZ = []
      let optAU = []
      let locArr = []
      let selectedName = ''
      let selectedValue = ''

      // - filter partner locations
      let sactionedLocations = []
      if (partner && _.some(models.partners, { mode })) {
        sactionedLocations = _.filter(locations, l => _.includes(partner.locations, `${l.id}`))
      } else {
        sactionedLocations = locations
      }
      Object.keys(sactionedLocations).forEach((key, index) => {
        if (sactionedLocations[key].country == 'nz') {
          if (defaultCountry == 'nz' && sactionedLocations[key].selected) {
            selectedName = sactionedLocations[key].name
            selectedValue = `${sactionedLocations[key].country}-${sactionedLocations[key].code}-${sactionedLocations[key].island}`
          }

          if (quotation.split) {
            // Split Booking Validation
            if (sactionedLocations[key].island == quotation.trips[quotation.trip].pickupIsland) {
              optNZ.push({
                value: `${sactionedLocations[key].country}-${sactionedLocations[key].code}-${sactionedLocations[key].island}`,
                label: sactionedLocations[key].name,
              })
            }
          } else {
            optNZ.push({
              value: `${sactionedLocations[key].country}-${sactionedLocations[key].code}-${sactionedLocations[key].island}`,
              label: sactionedLocations[key].name,
            })
          }
        } else if (sactionedLocations[key].country == 'au') {
          if (defaultCountry == 'au' && sactionedLocations[key].selected) {
            selectedName = sactionedLocations[key].name
            selectedValue = `${sactionedLocations[key].country}-${sactionedLocations[key].code}`
          }

          optAU.push({
            value: `${sactionedLocations[key].country}-${sactionedLocations[key].code}`,
            label: sactionedLocations[key].name,
          })
        }

        locArr[sactionedLocations[key].code] = sactionedLocations[key]
      })

      setLocationsArr(locArr)

      setNzOptions(optNZ)
      setAuOptions(optAU)

      let locOptions = [
        {
          label: 'New Zealand',
          options: _.orderBy(optNZ, ['label'], ['asc']),
        },
      ]

      if (quotation.split) {
        setPickupOptions(locOptions)
        setDropoffOptions(locOptions)
        setPickupLocation([
          {
            label: _.find(sactionedLocations, {
              code: quotation.trips[quotation.trip].pickup,
            }).name,
            value: `${quotation.country}-${quotation.trips[quotation.trip].pickup}${
              quotation.trips[quotation.trip].pickupIsland
                ? `${quotation.trips[quotation.trip].pickupIsland}`
                : ''
            }`,
          },
        ])
        setDropoffLocation([
          {
            label: _.find(sactionedLocations, {
              code: quotation.trips[quotation.trip].return,
            }).name,
            value: `${quotation.country}-${quotation.trips[quotation.trip].return}${
              quotation.trips[quotation.trip].returnIsland
                ? `-${quotation.trips[quotation.trip].returnIsland}`
                : ''
            }`,
          },
        ])
      } else if (!_.isEmpty(quotation.trips[quotation.trip].rates)) {
        // // console.log('EMREEEEEEEEEEEEEEE')

        // locOptions.push({
        //     label: _.find(sactionedLocations, {
        //         code: quotation.trips[quotation.trip].pickup,
        //     }).name,
        //     value: `${quotation.country}-${quotation.trips[quotation.trip].pickup}-${
        //         quotation.trips[quotation.trip].pickupIsland
        //     }`,
        // })

        locOptions.push({
          label: 'Australia',
          options: _.orderBy(optAU, ['label'], ['asc']),
        })

        if (defaultCountry == 'au') {
          locOptions.reverse()
        }

        setPickupOptions(locOptions)
        setDropoffOptions([
          {
            label: defaultCountry == 'nz' ? 'New Zealand' : 'Australia',
            options:
              defaultCountry == 'nz'
                ? _.orderBy(optNZ, ['label'], ['asc'])
                : _.orderBy(optAU, ['label'], ['asc']),
          },
        ])
        setPickupLocation([
          {
            label: _.find(sactionedLocations, {
              code: quotation.trips[quotation.trip].pickup,
            }).name,
            value: `${quotation.country}-${quotation.trips[quotation.trip].pickup}${
              quotation.trips[quotation.trip].pickupIsland
                ? `-${quotation.trips[quotation.trip].pickupIsland}`
                : ''
            }`,
          },
        ])
        setDropoffLocation([
          {
            label: _.find(sactionedLocations, {
              code: quotation.trips[quotation.trip].return,
            }).name,
            value: `${quotation.country}-${quotation.trips[quotation.trip].return}${
              quotation.trips[quotation.trip].returnIsland
                ? `-${quotation.trips[quotation.trip].returnIsland}`
                : ''
            }`,
          },
        ])
      } else {
        locOptions.push({
          label: 'Australia',
          options: _.orderBy(optAU, ['label'], ['asc']),
        })

        if (defaultCountry == 'au') {
          locOptions.reverse()
        }

        setPickupOptions(locOptions)

        setDropoffOptions([
          {
            value: 'same-0',
            label: Object.keys(itineraryLbls).length !== 0 ? itineraryLbls.same_as_pickup : '',
          },
          {
            label: defaultCountry == 'nz' ? 'New Zealand' : 'Australia',
            options:
              defaultCountry == 'nz'
                ? _.orderBy(optNZ, ['label'], ['asc'])
                : _.orderBy(optAU, ['label'], ['asc']),
          },
        ])

        // - TODO: convert this to allow control via CMS
        setPickupLocation([
          {
            label: !_.isEmpty(selectedName) ? selectedName : 'Select a location',
            value: !_.isEmpty(selectedValue) ? selectedValue : '',
          },
        ])
        setDropoffLocation([
          {
            label: Object.keys(itineraryLbls).length !== 0 ? itineraryLbls.same_as_pickup : '',
            value: 'same-0',
          },
        ])
      }

      // Check Search mode
      if (!searchMode) {
        const urlArr = _.split(decodeURI(location.href), '?', 2)
        const sParams = new URLSearchParams(urlArr.length > 1 ? urlArr[1].toString() : '')
        if (sParams.has('type') && sParams.get('type') == 'search') {
          if (
            sParams.has('pickup') &&
            sParams.has('pickupDate') &&
            sParams.has('pickupTime') &&
            sParams.has('dropoff') &&
            sParams.has('dropoffDate') &&
            sParams.has('dropoffTime') &&
            sParams.has('driver') &&
            sParams.has('promo')
          ) {
            setSearchMode(true)
            setSearchParams(sParams)
          }
        }
      }
    } else {
      // Empty Locations Object
    }
  }

  const setupDateTime = () => {
    let today = new Date()
    today = today.setDate(today.getDate() + 1)

    if (quotation.split) {
      const from = new Date(quotation.trips[quotation.trip].from)
      const until = new Date(quotation.trips[quotation.trip].until)

      setPickupDate(from)
      setDropoffDate(until)

      if (quotation.trip == 1) {
        setPickupMinDate(today)
        setDropoffMinDate(from)
      } else {
        const firstUntil = new Date(quotation.trips[1].until)

        setPickupMinDate(firstUntil)
        setDropoffMinDate(firstUntil)
      }
    } else if (!_.isEmpty(quotation.trips[quotation.trip].rates)) {
      const from = new Date(quotation.trips[quotation.trip].from)
      const until = new Date(quotation.trips[quotation.trip].until)

      setPickupDate(from)
      setDropoffDate(until)

      setPickupMinDate(today)
      setDropoffMinDate(from)
    }
  }

  const appendLeadingZeroes = n => {
    if (n <= 9) {
      return '0' + n
    }
    return n
  }

  const checkPromocode = data => {
    if (mode == 'default') {
      dispatch(modelsActions.checkPromocode(data))
    } else {
      if (pageLoaded) {
        getRates()
      }
    }
  }

  const checkRelocation = data => {
    dispatch(modelsActions.checkRelocation(data))
  }

  const checkAvailability = () => {
    if (clickedSearchFinal || true) {
      // bypass clickedSearchFinal
      setClickedSearchFinal(false)

      if (quotation.split) {
        setupDateTime() // Refresh Date Time selectors

        let { splitDateSelected } = quotation
        let { trip } = quotation
        if (pageLoaded && clickedSearchSplit) {
          if (quotation.trip == 1 && splitDateSelected == 0) {
            splitDateSelected++
            trip = 2
          } else if (quotation.trip == 2 && splitDateSelected == 1) {
            splitDateSelected++
            trip = 1
            let info_message = 'Please select a Vehicle for Trip 1.'
            addToast(info_message, {
              appearance: 'info',
              autoDismiss: true,
            })
          }
          setClickedSearchSplit(false)
        }

        if (!_.isEmpty(quotation.trips[quotation.trip].car)) {
          // Clear Vehicle Details and Change Phase
          dispatch(
            quotationActions.setQuotation({
              data: {
                ...quotation,
                phase: 'searchresult',
                splitDateSelected: splitDateSelected,
                trip: trip,
                trips: {
                  ...quotation.trips,
                  [quotation.trip]: {
                    ...quotation.trips[quotation.trip],
                    car: '',
                    initCar: '',
                    rid: '',
                  },
                },
              },
            }),
          )
        } else {
          // Change Phase
          dispatch(
            quotationActions.setQuotation({
              data: {
                ...quotation,
                phase: 'searchresult',
                splitDateSelected: splitDateSelected,
                trip: trip,
              },
            }),
          )
        }

        // Validation for Init Split Booking
        if (splitInit) {
          // redirect to review/holding page
          if (!_.isEmpty(quotation.trips[quotation.trip].rates[quotation.mode])) {
            window.location = '/bookings/create'
          }
        } else {
          // Apply code for update and refresh review/holding page
          // Close Booking Widget
          // Update splitPhase in Global State to 'searchresult'
          // Display vehicle component
        }
      } else {
        if (!_.isEmpty(quotation.trips[quotation.trip].car)) {
          // Clear Vehicle Details and Change Phase
          dispatch(
            quotationActions.setQuotation({
              data: {
                ...quotation,
                phase: 'searchresult',
                trips: {
                  ...quotation.trips,
                  [quotation.trip]: {
                    ...quotation.trips[quotation.trip],
                    car: '',
                    initCar: '',
                    rid: '',
                  },
                },
              },
            }),
          )
        } else {
          // Change Phase
          dispatch(
            quotationActions.setQuotation({
              data: {
                ...quotation,
                phase: 'searchresult',
              },
            }),
          )
        }

        if (
          location.pathname.indexOf('/bookings/') == -1 ||
          (_.startsWith(location.pathname, '/bookings/searchresult') && searchMode)
        ) {
          // redirect to review/holding page
          if (!_.isEmpty(quotation.trips[quotation.trip].rates[quotation.mode])) {
            window.location = '/bookings/create'
          }
        } else if (location.pathname.indexOf('/bookings/create') != -1) {
          // - on bookings create implement slider or lightbox search results
          // - we can actually deprecate the /bookings/searchresults route in favor of this slider solution.
          // Continue
        }
      }
    }
  }

  const validate = () => {
    let locp = pickupLocation[0].value.split('-')
    let ploc = locationsArr[locp[1]]
    let msg = ''
    if (driverAge[0].value == 0) {
      msg = "Please Select Driver's Age"
    }

    if (ploc && ploc.effectivedate && ploc.effectivedate != null && ploc.effectivedate != '') {
      let pickupDateFormatted =
        pickupDate.getFullYear() +
        '-' +
        appendLeadingZeroes(pickupDate.getMonth() + 1) +
        '-' +
        appendLeadingZeroes(pickupDate.getDate())
      let formPickupDate = new Date(pickupDateFormatted)
      let effectiveDate = new Date(ploc.effectivedate)

      if (formPickupDate < effectiveDate) {
        msg = 'This Location is only accepting bookings from ' + ploc.effectivedate + '.'
      }
    }

    if (mode != 'default') {
      const pd = moment(pickupDate.toJSON(), 'YYYY-MM-DDTHH:mm:ss.SSSZ')
      const dd = moment(dropoffDate.toJSON(), 'YYYY-MM-DDTHH:mm:ss.SSSZ')
      const min = pd.add(partner.minimum_days, 'd')

      if (min.isAfter(dd)) {
        msg = `This booking requires a minumum of ${partner.minimum_days} days`
      }
    }

    return msg
  }

  const onIframeSearch = () => {
    setIframe(true)
    onSearch()
  }

  const getDay = num => {
    let day = ''
    switch (num) {
      case 0:
        day = 'sunday'
        break
      case 1:
        day = 'monday'
        break
      case 2:
        day = 'tuesday'
        break
      case 3:
        day = 'wednesday'
        break
      case 4:
        day = 'thursday'
        break
      case 5:
        day = 'friday'
        break
      case 6:
        day = 'saturday'
        break
    }
    return day
  }

  const onSearch = () => {
    searchButtonClicked = true

    let sameFlag,
      locp,
      locd,
      pickupDateFormatted,
      pickupTimeFormatted,
      dropoffDateFormatted,
      dropoffTimeFormatted,
      formDriver,
      formPromo,
      car

    if (searchMode) {
      // pickup location
      locp = searchParams.get('pickup').split('-')

      // dropoff location
      locd = searchParams.get('dropoff').split('-')

      // Date and Time Formatted
      pickupDateFormatted = searchParams.get('pickupDate')
      pickupTimeFormatted = searchParams.get('pickupTime')
      dropoffDateFormatted = searchParams.get('dropoffDate')
      dropoffTimeFormatted = searchParams.get('dropoffTime')

      formDriver = searchParams.get('driver')
      formPromo = searchParams.get('promo')
      car = searchParams.get('car')

      // Locations
      if (searchParams.has('pickup')) {
        if (searchParams.get('pickup').indexOf('nz-', 0) !== -1) {
          //true
          // NZ

          if (pickupLocation[0].value.indexOf('au-', 0) !== -1) {
            // Check current option
            setDropoffOptions([
              {
                label: 'New Zealand',
                options: nzOptions,
              },
            ])
            setDropoffLocation([
              {
                label: locationsArr[searchParams.get('dropoff').split('-')[1]].name,
                value: searchParams.get('dropoff'),
              },
            ])
          }
          setPickupLocation([
            {
              label: locationsArr[searchParams.get('pickup').split('-')[1]].name,
              value: searchParams.get('pickup'),
            },
          ])
        } else if (searchParams.get('pickup').indexOf('au-', 0) !== -1) {
          //true
          // AU

          if (pickupLocation[0].value.indexOf('nz-', 0) !== -1) {
            // Check previous option
            setDropoffOptions([
              {
                label: 'Australia',
                options: auOptions,
              },
            ])
            setDropoffLocation([
              {
                label: locationsArr[searchParams.get('dropoff').split('-')[1]].name,
                value: searchParams.get('dropoff'),
              },
            ])
          }
          setPickupLocation([
            {
              label: locationsArr[searchParams.get('pickup').split('-')[1]].name,
              value: searchParams.get('pickup'),
            },
          ])
        }
      }

      // Date and Time
      let today = new Date()
      today = today.setDate(today.getDate() + 1)

      const from = new Date(`${pickupDateFormatted}T${pickupTimeFormatted}`)
      const until = new Date(`${dropoffDateFormatted}T${dropoffTimeFormatted}`)

      setPickupDate(from)
      setDropoffDate(until)

      setPickupMinDate(today)
      setDropoffMinDate(from)

      // Driver Age
      let optAgeSelected = []
      _.forEach(driveAgeOptions, ageObj => {
        if (formDriver == ageObj.value) {
          optAgeSelected.push({ label: ageObj.label, value: ageObj.value })
        }
      })
      setDriverAge(optAgeSelected)

      // Promo
      setPromo(formPromo)
    } else {
      // Same Location Flag
      sameFlag = dropoffLocation[0].value == 'same-0'

      // pickup location
      locp = pickupLocation[0].value.split('-')

      // dropoff location
      locd = sameFlag ? pickupLocation[0].value.split('-') : dropoffLocation[0].value.split('-')

      // Date and Time Formatted
      pickupDateFormatted =
        pickupDate.getFullYear() +
        '-' +
        appendLeadingZeroes(pickupDate.getMonth() + 1) +
        '-' +
        appendLeadingZeroes(pickupDate.getDate())
      pickupTimeFormatted =
        appendLeadingZeroes(pickupDate.getHours()) +
        ':' +
        appendLeadingZeroes(pickupDate.getMinutes()) +
        ':' +
        appendLeadingZeroes(pickupDate.getSeconds())
      dropoffDateFormatted =
        dropoffDate.getFullYear() +
        '-' +
        appendLeadingZeroes(dropoffDate.getMonth() + 1) +
        '-' +
        appendLeadingZeroes(dropoffDate.getDate())
      dropoffTimeFormatted =
        appendLeadingZeroes(dropoffDate.getHours()) +
        ':' +
        appendLeadingZeroes(dropoffDate.getMinutes()) +
        ':' +
        appendLeadingZeroes(dropoffDate.getSeconds())

      formDriver = driverAge[0].value
      formPromo = promo
    }

    // DateTime Objects
    let formPickupDateTime = new Date(pickupDateFormatted + 'T' + pickupTimeFormatted)
    let formDropoffDateTime = new Date(dropoffDateFormatted + 'T' + dropoffTimeFormatted)

    // Pickup Day Value
    let pickupDay = getDay(formPickupDateTime.getDay())

    // Today Date Object and Formatted value
    let today = new Date()
    let todayDateFormatted =
      today.getFullYear() +
      '-' +
      appendLeadingZeroes(today.getMonth() + 1) +
      '-' +
      appendLeadingZeroes(today.getDate())

    // Number of Booking Days
    let days = (formDropoffDateTime.getTime() - formPickupDateTime.getTime()) / (1000 * 3600 * 24)

    if ((defaultCountry != locp[0] || iframe) && !searchMode) {
      // Bookings Search - Needs route and permalink url with search data
      let urlObj = {
        type: 'search',
        pickup: pickupLocation[0].value,
        pickupDate: pickupDateFormatted,
        pickupTime: pickupTimeFormatted,
        dropoff: sameFlag ? pickupLocation[0].value : dropoffLocation[0].value,
        dropoffDate: dropoffDateFormatted,
        dropoffTime: dropoffTimeFormatted,
        driver: formDriver,
        promo: formPromo,
      }

      const urlGen = (urlObj, country, iframe) => {
        let url = window.location.host
        if (iframe && _.includes(url, 'blog.')) {
          url = _.replace(url, 'blog.', 'www.') // Won't need this when Blog integrated with website
        }
        url = _.replace(
          url,
          country == 'nz' ? 'com.au' : 'co.nz',
          country == 'nz' ? 'co.nz' : 'com.au',
        )

        return encodeURI(
          'http://' +
            url +
            '/bookings/searchresult?' +
            Object.entries(urlObj)
              .map(([key, val]) => `${key}=${val}`)
              .join('&'),
        )
      }

      if (iframe) {
        // window.parent.location.href = ...
        window.parent.location = urlGen(urlObj, locp[0], iframe)
      } else {
        // window.location.href = ...
        window.location = urlGen(urlObj, locp[0], iframe)
      }
    } else {
      let msg = validate()

      if (msg) {
        addToast(msg, {
          appearance: 'error',
          autoDismiss: true,
        })
      } else {
        // - clear promocode check for next search
        dispatch(modelsActions.clearPromocode())

        if (pickupDateFormatted == todayDateFormatted && formPickupDateTime < today) {
          let error_message =
            'Sorry the Pickup time selected has lapsed. Please select a different Pickup time to book.'
          // let heading="Oops! Looks like something is missing!"
          // use custom popup with title
          addToast(error_message, {
            appearance: 'error',
            autoDismiss: true,
          })
        } else {
          if ((promo.toUpperCase() == 'IDP3K' || promo.toUpperCase() == 'IDP5K') && days < 30) {
            let error_message = 'Sorry the promocode is only valid with a minimum 30 days booking.'
            // let heading="Oops! Looks like something is missing!"
            // use custom popup with title
            addToast(error_message, {
              appearance: 'error',
              autoDismiss: true,
            })
            return false
          }

          // Check for After Hours Pickup
          let pickupCode = pickupLocation[0].value.split('-')[1]
          let pickupLocHours = locationsArr[pickupCode].hours

          if (locationsArr[pickupCode].drop_off_hours) {
            pickupLocHours = locationsArr[pickupCode].drop_off_hours
          }

          if (pickupLocHours.length < 1) pickupLocHours = pickupLocHours

          pickupLocHours.forEach(function(hrs) {
            if (hrs.day == pickupDay) {
              let openingTime = new Date(pickupDateFormatted + 'T' + hrs.opening_time + ':00')
              let closingTime = new Date(pickupDateFormatted + 'T' + hrs.closing_time + ':00')
              if (formPickupDateTime < openingTime || formPickupDateTime > closingTime) {
                setAfterHourPickup(true)
              }
            }
          })

          if (afterHourPickup && quotation.mode == 'uber') {
            // Need to work on switching Modes (Default mode: home)
            let error_message =
              'Sorry This pick-up time falls outside of the Business hours of our Branch. Need help? Please Contact support@acerentalcars.' +
              (defaultCountry == 'nz' ? 'co.nz' : 'com.au')
            // let heading = "Oops! Looks like something is missing!"
            // use custom popup with title
            addToast(error_message, {
              appearance: 'error',
              autoDismiss: true,
            })
          } else {
            // Splitbooking Check
            if (!quotation.split && defaultCountry == 'nz') {
              if (locd[2] != locp[2]) {
                if (
                  splitbooking &&
                  promo.trim().toUpperCase() != 'RELOCATION' &&
                  promo.trim().toUpperCase() != 'RELOCATIONS'
                ) {
                  if (locp[2] == 'north' && splitbookingToSouthNotAllowed) {
                    alert('Click OK to continue with one multi Island booking!')
                  } else if (locp[2] == 'south' && splitbookingToNorthNotAllowed) {
                    alert('Click OK to continue with one multi Island booking!')
                  } else if (locp[2] == 'north') {
                    alert(
                      'Save on Relocation Fees and the Cost of taking the vehicle on the ferry by making two bookings – drop your first hire off at our Wellington branch and then collect your second hire from our Picton branch!',
                    )
                    setSplitInit(true)
                  } else if (locp[2] == 'south') {
                    alert(
                      'Save on Relocation Fees and the Cost of taking the vehicle on the ferry by making two bookings – drop your first hire off at our Picton branch and then collect your second hire from our Wellington branch!',
                    )
                    setSplitInit(true)
                  }
                } else if (locp[2] == 'north') {
                  if (splitbookingToNorthNotAllowed) {
                    alert(
                      'Unfortunately, a multi Island booking from North to South island is not permitted! However you can create two bookings one booking with a drop off location of Wellington and the second booking with a pickup in Picton.',
                    )
                    return false
                  } else {
                    // Continue
                  }
                } else if (locp[2] == 'south') {
                  if (splitbookingToSouthNotAllowed) {
                    alert(
                      'Unfortunately, a multi Island booking from South to North island is not permitted! However you can create two bookings one booking with a drop off location of Picton and the second booking with a pickup in Wellington.',
                    )
                    return false
                  } else {
                    // Continue
                  }
                }
              }
            }

            let form = {
              pickup: pickupLocation[0].value.split('-')[1],
              return:
                dropoffLocation[0].value == 'same-0'
                  ? pickupLocation[0].value.split('-')[1]
                  : dropoffLocation[0].value.split('-')[1],
              from:
                pickupDate.getFullYear() +
                '-' +
                appendLeadingZeroes(pickupDate.getMonth() + 1) +
                '-' +
                appendLeadingZeroes(pickupDate.getDate()) +
                ' ' +
                appendLeadingZeroes(pickupDate.getHours()) +
                ':' +
                appendLeadingZeroes(pickupDate.getMinutes()) +
                ':' +
                appendLeadingZeroes(pickupDate.getSeconds()),
              until:
                dropoffDate.getFullYear() +
                '-' +
                appendLeadingZeroes(dropoffDate.getMonth() + 1) +
                '-' +
                appendLeadingZeroes(dropoffDate.getDate()) +
                ' ' +
                appendLeadingZeroes(dropoffDate.getHours()) +
                ':' +
                appendLeadingZeroes(dropoffDate.getMinutes()) +
                ':' +
                appendLeadingZeroes(dropoffDate.getSeconds()),
              age: formDriver,
              promo: formPromo,
              relocationID: quotation.relocationID,
              days: days,
            }

            setPromoChecked(false)
            setRelocationChecked(false)
            setAvailabilityCheck(false)

            if (
              promo.trim().toUpperCase() == 'RELOCATION' ||
              promo.trim().toUpperCase() == 'RELOCATIONS'
            ) {
              checkRelocation({
                data: {
                  ...form,
                },
              })
            } else {
              checkPromocode({
                data: {
                  ...form,
                },
              })
            }
          }
        }
      }
    }
  }

  const getRates = () => {
    // Manage Events after Search Clicked
    if (searchButtonClicked) {
      if (quotation.phase == 'searchresult' && _.startsWith(location.pathname, '/bookings/')) {
        setClickedSearchSplit(true)
      }
      setClickedSearchFinal(true)
    }

    searchButtonClicked = false

    let pickupCode = pickupLocation[0].value.split('-')[1]
    let returnCode =
      dropoffLocation[0].value == 'same-0'
        ? pickupLocation[0].value.split('-')[1]
        : dropoffLocation[0].value.split('-')[1]
    let depositAllowed = false

    if (promoChecked && !_.isEmpty(promo) && _.has(promocode, 'CDP')) {
      const isblackoutdates = promocode.blackoutdates.filter((bdr, i) => {
        if (moment(pickupDate.toJSON()).isBetween(bdr.from, bdr.to)) {
          return true
        }

        return false
      })

      let blackoutL = []
      if (!_.isEmpty(promocode.blackoutlocations) && promocode.blackoutlocations != 0) {
        blackoutL = _.map(promocode.blackoutlocations, locID => {
          return _.find(locations, { id: parseInt(locID) }) !== undefined
            ? _.find(locations, { id: parseInt(locID) }).code
            : ''
        })
      }

      const isblackoutlocations = () => {
        if (!_.isEmpty(blackoutL)) {
          return _.indexOf(blackoutL, pickupCode) != -1
        }

        return false
      }

      if (!_.isEmpty(promocode.blackoutdates) && !_.isEmpty(isblackoutdates)) {
        let error_message = 'Sorry, this promocode is not applicable for this date.'
        addToast(error_message, {
          appearance: 'error',
          autoDismiss: true,
        })

        return false
      } else if (isblackoutlocations()) {
        let error_message = 'Sorry, this promocode is not applicable for this location.'
        addToast(error_message, {
          appearance: 'error',
          autoDismiss: true,
        })

        return false
      } else if (
        promocode.minimumdays > 0 &&
        Math.abs(
          moment(pickupDate.toJSON(), 'YYYY-MM-DD').diff(
            moment(dropoffDate.toJSON(), 'YYYY-MM-DD'),
            'days',
          ),
        ) < promocode.minimumdays
      ) {
        let error_message = `This promocode is not applicable for a booking that has less than ${promocode.minimumdays} days.`
        addToast(error_message, {
          appearance: 'error',
          autoDismiss: true,
        })

        return false
      } else if (
        promocode.maximumdays > 0 &&
        Math.abs(
          moment(pickupDate.toJSON(), 'YYYY-MM-DD').diff(
            moment(dropoffDate.toJSON(), 'YYYY-MM-DD'),
            'days',
          ),
        ) > promocode.maximumdays
      ) {
        let error_message = `This promocode is not applicable for a booking that has more than ${promocode.maximumdays} days.`
        addToast(error_message, {
          appearance: 'error',
          autoDismiss: true,
        })

        return false
      }

      if (quotation.mode != 'travelpartner' && promocode.depositnotallowed) {
        depositAllowed = false
      }
    }

    const splitBookingNorthLocation = 'nz-ACW60-North' // Wellington City
    const splitBookingSouthLocation = 'nz-ACP60-South' // Picton

    if (splitInit) {
      // Split Booking Initiated

      // Validation
      const firstIsland = pickupLocation[0].value.split('-')[2]
      const secondIsland = dropoffLocation[0].value.split('-')[2]

      let fixedPickup = splitBookingSouthLocation
      let fixedDropoff = splitBookingNorthLocation
      if (firstIsland == 'South') {
        fixedPickup = splitBookingNorthLocation
        fixedDropoff = splitBookingSouthLocation
      }

      let firstPickupDateTime = moment(pickupDate.toJSON()).format('YYYY-MM-DD HH:mm:ss')
      let firstDropoffDateTime = moment(pickupDate.toJSON())
        .add(1, 'days')
        .format('YYYY-MM-DD HH:mm:ss')

      let secondPickupDateTime = moment(dropoffDate.toJSON())
        .subtract(1, 'days')
        .format('YYYY-MM-DD HH:mm:ss')
      let secondDropoffDateTime = moment(dropoffDate.toJSON()).format('YYYY-MM-DD HH:mm:ss')

      if (firstDropoffDateTime > secondPickupDateTime) {
        secondPickupDateTime = moment(firstDropoffDateTime)
          .add(60, 'minutes')
          .format('YYYY-MM-DD HH:mm:ss')
        secondDropoffDateTime = moment(secondPickupDateTime)
          .add(1, 'day')
          .format('YYYY-MM-DD HH:mm:ss')
      }

      const form = {
        [1]: {
          pickup: pickupLocation[0].value.split('-')[1],
          pickupIsland: firstIsland,
          return: fixedDropoff.split('-')[1],
          returnIsland: firstIsland,
          from:
            moment(firstPickupDateTime).format('YYYY-MM-DD') +
            'T' +
            moment(firstPickupDateTime).format('HH:mm:ss'),
          until:
            moment(firstDropoffDateTime).format('YYYY-MM-DD') +
            'T' +
            moment(firstDropoffDateTime).format('HH:mm:ss'),
          dob: driverAge[0].value,
          promo: promo,
          cdp: '',
          afterHoursPickup: afterHourPickup,
        },
        [2]: {
          pickup: fixedPickup.split('-')[1],
          pickupIsland: secondIsland,
          return: dropoffLocation[0].value.split('-')[1],
          returnIsland: secondIsland,
          from:
            moment(secondPickupDateTime).format('YYYY-MM-DD') +
            'T' +
            moment(secondPickupDateTime).format('HH:mm:ss'),
          until:
            moment(secondDropoffDateTime).format('YYYY-MM-DD') +
            'T' +
            moment(secondDropoffDateTime).format('HH:mm:ss'),
          dob: driverAge[0].value,
          promo: promo,
          cdp: '',
          afterHoursPickup: afterHourPickup,
        },
      }

      dispatch(
        quotationActions.setQuotation({
          data: {
            ...quotation,
            country: defaultCountry,
            split: true,
            depositAllowed: depositAllowed,
            trips: {
              ...quotation.trips,
              [1]: {
                ...quotation.trips[1],
                ...form[1],
                promo:
                  promoChecked && !_.isEmpty(promocode) && _.has(promocode, 'CDP') ? promo : '',
                cdp:
                  promoChecked && !_.isEmpty(promocode) && _.has(promocode, 'CDP')
                    ? promocode.CDP
                    : '',
              },
              [2]: {
                ...quotation.trips[2],
                ...form[2],
                promo:
                  promoChecked && !_.isEmpty(promocode) && _.has(promocode, 'CDP') ? promo : '',
                cdp:
                  promoChecked && !_.isEmpty(promocode) && _.has(promocode, 'CDP')
                    ? promocode.CDP
                    : '',
              },
            },
          },
        }),
      )

      // Get Rates
      dispatch(
        ratesActions.getRates({
          method: 'Rates',
          data: {
            index: quotation.mode,
            trip: 1, // Added Value for Split Booking
            ref: uuidv4(),
            ...form[1],
          },
        }),
      )

      // Get Rates
      dispatch(
        ratesActions.getRates({
          method: 'Rates',
          data: {
            index: quotation.mode,
            trip: 2, // Added Value for Split Booking
            ref: uuidv4(),
            ...form[2],
          },
        }),
      )

      // Get Promo Rates
      if (promoChecked && !_.isEmpty(promocode) && _.has(promocode, 'CDP')) {
        dispatch(
          ratesActions.getPromoRates({
            method: 'Rates',
            data: {
              index: 'promo',
              trip: 1, // Added Value for Split Booking
              ref: uuidv4(),
              ...form[1],
              promo: promocode.CDP,
              cdp: promocode.CDP,
            },
          }),
        )

        dispatch(
          ratesActions.getPromoRates({
            method: 'Rates',
            data: {
              index: 'promo',
              trip: 2, // Added Value for Split Booking
              ref: uuidv4(),
              ...form[2],
              promo: promocode.CDP,
              cdp: promocode.CDP,
            },
          }),
        )
      }
    } else if (quotation.split) {
      // Continue Split Booking

      // Validation
      const firstIsland =
        quotation.trip == 1
          ? pickupLocation[0].value.split('-')[2]
          : quotation.trips[1].pickupIsland
      const secondIsland =
        quotation.trip == 1
          ? quotation.trips[2].pickupIsland
          : pickupLocation[0].value.split('-')[2]

      let fixedPickup = splitBookingSouthLocation
      let fixedDropoff = splitBookingNorthLocation
      if (firstIsland == 'South') {
        fixedPickup = splitBookingNorthLocation
        fixedDropoff = splitBookingSouthLocation
      }

      let firstPickup =
        quotation.trip == 1 ? pickupLocation[0].value.split('-')[1] : quotation.trips[1].pickup
      let secondDropoff =
        quotation.trip == 1 ? quotation.trips[2].return : dropoffLocation[0].value.split('-')[1]

      let firstPickupDateTime =
        quotation.trip == 1
          ? moment(pickupDate.toJSON()).format('YYYY-MM-DD HH:mm:ss')
          : moment(quotation.trips[1].from).format('YYYY-MM-DD HH:mm:ss')
      let firstDropoffDateTime =
        quotation.trip == 1
          ? moment(dropoffDate.toJSON()).format('YYYY-MM-DD HH:mm:ss')
          : moment(quotation.trips[1].until).format('YYYY-MM-DD HH:mm:ss')

      let secondPickupDateTime =
        quotation.trip == 2
          ? moment(pickupDate.toJSON()).format('YYYY-MM-DD HH:mm:ss')
          : moment(quotation.trips[2].from).format('YYYY-MM-DD HH:mm:ss')
      let secondDropoffDateTime =
        quotation.trip == 2
          ? moment(dropoffDate.toJSON()).format('YYYY-MM-DD HH:mm:ss')
          : moment(quotation.trips[2].until).format('YYYY-MM-DD HH:mm:ss')

      if (firstDropoffDateTime >= secondPickupDateTime) {
        if (quotation.trip == 1) {
          // Adjust Trip 1
          firstDropoffDateTime = moment(secondPickupDateTime)
            .subtract(60, 'minutes')
            .format('YYYY-MM-DD HH:mm:ss')
        } else {
          // Adjust Trip 2
          secondPickupDateTime = moment(firstDropoffDateTime)
            .add(60, 'minutes')
            .format('YYYY-MM-DD HH:mm:ss')
        }

        // secondPickupDateTime = moment(firstDropoffDateTime).add(60,'minutes').format('YYYY-MM-DD HH:mm:ss');
      }

      // if (secondPickupDateTime >= secondDropoffDateTime) {
      //     secondDropoffDateTime = moment(secondPickupDateTime).add(1, 'day').format('YYYY-MM-DD HH:mm:ss');
      // }

      const form = {
        [1]: {
          pickup: firstPickup,
          pickupIsland: firstIsland,
          return: fixedDropoff.split('-')[1],
          returnIsland: firstIsland,
          from:
            moment(firstPickupDateTime).format('YYYY-MM-DD') +
            'T' +
            moment(firstPickupDateTime).format('HH:mm:ss'),
          until:
            moment(firstDropoffDateTime).format('YYYY-MM-DD') +
            'T' +
            moment(firstDropoffDateTime).format('HH:mm:ss'),
          dob: driverAge[0].value,
          promo: promo,
          cdp: '',
          afterHoursPickup: afterHourPickup,
        },
        [2]: {
          pickup: fixedPickup.split('-')[1],
          pickupIsland: secondIsland,
          return: secondDropoff,
          returnIsland: secondIsland,
          from:
            moment(secondPickupDateTime).format('YYYY-MM-DD') +
            'T' +
            moment(secondPickupDateTime).format('HH:mm:ss'),
          until:
            moment(secondDropoffDateTime).format('YYYY-MM-DD') +
            'T' +
            moment(secondDropoffDateTime).format('HH:mm:ss'),
          dob: driverAge[0].value,
          promo: promo,
          cdp: '',
          afterHoursPickup: afterHourPickup,
        },
      }

      dispatch(
        quotationActions.setQuotation({
          data: {
            ...quotation,
            trips: {
              ...quotation.trips,
              [1]: {
                ...quotation.trips[1],
                ...form[1],
                promo:
                  promoChecked && !_.isEmpty(promocode) && _.has(promocode, 'CDP') ? promo : '',
                cdp:
                  promoChecked && !_.isEmpty(promocode) && _.has(promocode, 'CDP')
                    ? promocode.CDP
                    : '',
              },
              [2]: {
                ...quotation.trips[2],
                ...form[2],
                promo:
                  promoChecked && !_.isEmpty(promocode) && _.has(promocode, 'CDP') ? promo : '',
                cdp:
                  promoChecked && !_.isEmpty(promocode) && _.has(promocode, 'CDP')
                    ? promocode.CDP
                    : '',
              },
            },
          },
        }),
      )

      // Get Rates
      dispatch(
        ratesActions.getRates({
          method: 'Rates',
          data: {
            index: quotation.mode,
            trip: 1, // Added Value for Split Booking
            ref: uuidv4(),
            ...form[1],
          },
        }),
      )

      // Get Rates
      dispatch(
        ratesActions.getRates({
          method: 'Rates',
          data: {
            index: quotation.mode,
            trip: 2, // Added Value for Split Booking
            ref: uuidv4(),
            ...form[2],
          },
        }),
      )

      // Get Promo Rates
      if (promoChecked && !_.isEmpty(promocode) && _.has(promocode, 'CDP')) {
        dispatch(
          ratesActions.getPromoRates({
            method: 'Rates',
            data: {
              index: 'promo',
              trip: 1, // Added Value for Split Booking
              ref: uuidv4(),
              ...form[1],
              promo: promocode.CDP,
              cdp: promocode.CDP,
            },
          }),
        )

        dispatch(
          ratesActions.getPromoRates({
            method: 'Rates',
            data: {
              index: 'promo',
              trip: 2, // Added Value for Split Booking
              ref: uuidv4(),
              ...form[2],
              promo: promocode.CDP,
              cdp: promocode.CDP,
            },
          }),
        )
      }
    } else {
      // Single Booking OR Split Booking after initial booking has been separated
      const form = {
        pickup: pickupCode,
        pickupIsland: defaultCountry == 'au' ? '' : pickupLocation[0].value.split('-')[2],
        return: returnCode,
        returnIsland:
          defaultCountry == 'au'
            ? ''
            : dropoffLocation[0].value == 'same-0'
            ? pickupLocation[0].value.split('-')[2]
            : dropoffLocation[0].value.split('-')[2],
        from:
          pickupDate.getFullYear() +
          '-' +
          appendLeadingZeroes(pickupDate.getMonth() + 1) +
          '-' +
          appendLeadingZeroes(pickupDate.getDate()) +
          'T' +
          appendLeadingZeroes(pickupDate.getHours()) +
          ':' +
          appendLeadingZeroes(pickupDate.getMinutes()) +
          ':' +
          appendLeadingZeroes(pickupDate.getSeconds()),
        until:
          dropoffDate.getFullYear() +
          '-' +
          appendLeadingZeroes(dropoffDate.getMonth() + 1) +
          '-' +
          appendLeadingZeroes(dropoffDate.getDate()) +
          'T' +
          appendLeadingZeroes(dropoffDate.getHours()) +
          ':' +
          appendLeadingZeroes(dropoffDate.getMinutes()) +
          ':' +
          appendLeadingZeroes(dropoffDate.getSeconds()),
        dob: driverAge[0].value,
        promo: promo,
        cdp: '',
        afterHoursPickup: afterHourPickup,
      }

      dispatch(
        quotationActions.setQuotation({
          data: {
            ...quotation,
            country: defaultCountry,
            split: false,
            depositAllowed: depositAllowed,
            trips: {
              ...quotation.trips,
              [quotation.trip]: {
                ...quotation.trips[quotation.trip],
                ...form,
                promo:
                  promoChecked && !_.isEmpty(promocode) && _.has(promocode, 'CDP') ? promo : '',
                cdp:
                  promoChecked && !_.isEmpty(promocode) && _.has(promocode, 'CDP')
                    ? promocode.CDP
                    : '',
              },
            },
          },
        }),
      )

      // Get Rates
      dispatch(
        ratesActions.getRates({
          method: 'Rates',
          data: {
            index: quotation.mode,
            trip: quotation.trip, // Added Value for Split Booking
            ref: uuidv4(),
            ...form,
          },
        }),
      )

      // Get Promo Rates
      if (promoChecked && !_.isEmpty(promocode) && _.has(promocode, 'CDP')) {
        dispatch(
          ratesActions.getPromoRates({
            method: 'Rates',
            data: {
              index: 'promo',
              trip: quotation.trip, // Added Value for Split Booking
              ref: uuidv4(),
              ...form,
              promo: promocode.CDP,
              cdp: promocode.CDP,
            },
          }),
        )
      }
    }

    // - clear promocode check for next search
    // dispatch(modelsActions.clearPromocode()) // Causes conflict, moved to onSearch
  }

  const handleSubmit = event => {
    event.preventDefault()
    onSearch()
  }

  const toggleDropoffLocation = visible => {
    if (!visible) {
      // Update Value
      setDropoffLocation([
        {
          label: Object.keys(itineraryLbls).length !== 0 ? itineraryLbls.same_as_pickup : '',
          value: 'same-0',
        },
      ])
    }
  }

  const selectHandleChange = (optionSelected, actionMeta) => {
    switch (actionMeta.name) {
      case 'formPickupLocation':
        if (actionMeta.action == 'select-option') {
          // Update Select Value
          var code = optionSelected.value.split('-')
          if (locationsArr[code[1]]) setFilterDate(locationsArr[code[1]].hours)

          if (optionSelected.value.indexOf('nz-', 0) !== -1) {
            //true
            // New Zealand Option Selected
            if (pickupLocation[0].value.indexOf('au-', 0) !== -1) {
              // Check previous option
              // Switch to Same as Pick Up
              setDropoffOptions([
                {
                  value: 'same-0',
                  label:
                    Object.keys(itineraryLbls).length !== 0 ? itineraryLbls.same_as_pickup : '',
                },
                {
                  label: 'New Zealand',
                  options: nzOptions,
                },
              ])
              setDropoffLocation([
                {
                  label:
                    Object.keys(itineraryLbls).length !== 0 ? itineraryLbls.same_as_pickup : '',
                  value: 'same-0',
                },
              ])
            }
            setPickupLocation([
              {
                label: optionSelected.label,
                value: optionSelected.value,
              },
            ])
            var code = optionSelected.value.split('-')

            if (locationsArr[code[1]].drop_off_hours) {
              if (locationsArr[code[1]].drop_off_hours.length > 0) {
                setglobalDropOffHours(locationsArr[code[1]].drop_off_hours)
              } else {
                setglobalDropOffHours(locationsArr[code[1]].hours)
              }
            } else {
              setglobalDropOffHours(locationsArr[code[1]].hours)
            }

            setDropoffDate(null)
          } else if (optionSelected.value.indexOf('au-', 0) !== -1) {
            // Australian Option Selected
            if (pickupLocation[0].value.indexOf('nz-', 0) !== -1) {
              // Check previous option
              // Switch to Same as Pick Up
              setDropoffOptions([
                {
                  value: 'same-0',
                  label:
                    Object.keys(itineraryLbls).length !== 0 ? itineraryLbls.same_as_pickup : '',
                },
                {
                  label: 'Australia',
                  options: auOptions,
                },
              ])
              setDropoffLocation([
                {
                  label:
                    Object.keys(itineraryLbls).length !== 0 ? itineraryLbls.same_as_pickup : '',
                  value: 'same-0',
                },
              ])
            }
            setPickupLocation([
              {
                label: optionSelected.label,
                value: optionSelected.value,
              },
            ])

            //setDropoffDate(dateNull);
          }
        }
        break
      case 'formDropoffLocation':
        if (actionMeta.action == 'select-option') {
          // Update Value
          setDropoffLocation([
            {
              label: optionSelected.label,
              value: optionSelected.value,
            },
          ])

          //Set the opening and closing hours
          var code = optionSelected.value.split('-')
          setglobalHours(locationsArr[code[1]].hours)
          setFilterDateDropOff(locationsArr[code[1]].hours)
          if (locationsArr[code[1]].drop_off_hours) {
            if (locationsArr[code[1]].drop_off_hours.length > 1) {
              setglobalDropOffHours(locationsArr[code[1]].drop_off_hours)
            } else {
              setglobalDropOffHours(locationsArr[code[1]].hours)
            }
          } else {
            setglobalDropOffHours(locationsArr[code[1]].hours)
          }

          //Set the pickuo and dropoff date to null on pickup location change
          let dateNull = null
          setDropoffDate(dateNull)
        }
        break
      case 'formMinimumAge':
        if (actionMeta.action == 'select-option') {
          // Update Value
          setDriverAge([
            {
              label: optionSelected.label,
              value: optionSelected.value,
            },
          ])
        }
        break
    }
  }
  // daysInWeek
  // dropoffMinDate
  const selectHandleFn = () => {
    const code = pickupLocation[0].value.split('-')
    const storehours = locationsArr[code[1]].hours
    //pickupMinDate.getDay()
    const splitTime = storehours
      .find(
        ({ day }) =>
          day === pickupMinDate.toLocaleDateString('en', { weekday: 'long' }).toLowerCase(),
      )
      .opening_time.split(':')

    let dropoffhours = storehours

    if (locationsArr[code[1]].drop_off_hours) {
      dropoffhours = locationsArr[code[1]].drop_off_hours
    }

    if (dropoffhours.length < 1) dropoffhours = storehours

    const splitTimeDropOff = dropoffhours
      .find(
        ({ day }) =>
          day === dropoffMinDate.toLocaleDateString('en', { weekday: 'long' }).toLowerCase(),
      )
      .opening_time.split(':')
    onPickupDateChange(setHours(setMinutes(pickupMinDate, splitTime[1]), splitTime[0]))
    onDropoffDateChange(
      setHours(setMinutes(dropoffMinDate, splitTimeDropOff[1]), splitTimeDropOff[0]),
    )
  }

  const selectHandleInputChange = (optionSelected, actionMeta) => {
    if (pickupLocation[0].value && !pickupDate) {
      selectHandleFn()
    }
  }

  const onPickupDateChange = date => {
    const codePickup = pickupLocation[0].value.split('-')
    const codeDropoff =
      dropoffLocation[0].value == 'same-0'
        ? pickupLocation[0].value.split('-')
        : dropoffLocation[0].value.split('-')

    const normalHours = locationsArr[codePickup[1]].hours

    let dropoffHours = normalHours

    if (locationsArr[codeDropoff[1]].drop_off_hours) {
      dropoffHours = locationsArr[codeDropoff[1]].drop_off_hours
    }

    if (dropoffHours.length < 1) dropoffHours = normalHours

    const splitTime = normalHours
      .find(({ day }) => day === date.toLocaleDateString('en', { weekday: 'long' }).toLowerCase())
      .opening_time.split(':')
    const splitClosingTime = normalHours
      .find(({ day }) => day === date.toLocaleDateString('en', { weekday: 'long' }).toLowerCase())
      .closing_time.split(':')

    const splitTimeDropOff = dropoffHours
      .find(({ day }) => day === date.toLocaleDateString('en', { weekday: 'long' }).toLowerCase())
      .opening_time.split(':')
    const splitClosingTimeDropOff = dropoffHours
      .find(({ day }) => day === date.toLocaleDateString('en', { weekday: 'long' }).toLowerCase())
      .closing_time.split(':')

    setglobalHours(normalHours)
    setglobalDropOffHours(dropoffHours)

    setglobalOpeningTime({
      hour: splitTime[0],
      min: splitTime[1],
    })

    setglobalClosingTime({
      hour: splitClosingTime[0],
      min: splitClosingTime[1],
    })

    setglobalDropOffOpeningTime({
      hour: splitTimeDropOff[0],
      min: splitTimeDropOff[1],
    })

    setglobalDropOffClosingTime({
      hour: splitClosingTimeDropOff[0],
      min: splitClosingTimeDropOff[1],
    })

    setPickupDate(date)
    if (date > dropoffDate) {
      setDropoffDate(addDays(date, 1))
      setDropoffMinDate(date)
    } else if (date == pickupMinDate) {
      setDropoffMinDate(addDays(date, 1))
    } else {
      setDropoffMinDate(date)
    }

    if (mode == 'uber') {
      let minDays = ''
      const partnerArr = models.partners

      for (var key in partnerArr) {
        if (partnerArr.hasOwnProperty(key)) {
          if (partnerArr[key].type === 1) {
            minDays = partnerArr[key].minimum_days
          }
        }
      }
      setDropoffDate(addDays(date, minDays))
      setDropoffMinDate(addDays(date, minDays))
    }
  }

  const onDropoffDateChange = date => {
    const codeDropoff =
      dropoffLocation[0].value == 'same-0'
        ? pickupLocation[0].value.split('-')
        : dropoffLocation[0].value.split('-')

    const normalHours = locationsArr[codeDropoff[1]].hours

    let dropoffHours = normalHours

    if (locationsArr[codeDropoff[1]].drop_off_hours) {
      dropoffHours = locationsArr[codeDropoff[1]].drop_off_hours
    }

    if (dropoffHours.length < 1) dropoffHours = normalHours

    const splitTime = dropoffHours
      .find(({ day }) => day === date.toLocaleDateString('en', { weekday: 'long' }).toLowerCase())
      .opening_time.split(':')

    const splitClosingTime = dropoffHours
      .find(({ day }) => day === date.toLocaleDateString('en', { weekday: 'long' }).toLowerCase())
      .closing_time.split(':')

    setglobalHours(normalHours)
    setglobalDropOffHours(dropoffHours)
    setglobalDropOffOpeningTime({
      hour: splitTime[0],
      min: splitTime[1],
    })
    setglobalDropOffClosingTime({
      hour: splitClosingTime[0],
      min: splitClosingTime[1],
    })

    setDropoffDate(date)
  }

  const promoChange = event => {
    setPromo(event.target.value)
  }

  const selectTrip = newTrip => {
    if (quotation.trip != newTrip) {
      if (quotation.splitDateSelected == 0 && quotation.trip == 1) {
        alert(`Please select a Drop Off Date and Time for Trip 1 and Search.`)
      } else if (quotation.splitDateSelected == 1 && quotation.trip == 2) {
        alert(`Please select a Pick Up Date and Time for Trip 2 and Search.`)
      } else if (_.isEmpty(quotation.trips[quotation.trip].car)) {
        alert(`Please select a Vehicle for Trip ${quotation.trip}`)
      } else if (!_.isEmpty(quotation.trips[newTrip].res)) {
        alert(`Please complete Payment of Trip ${quotation.trip}`)
      } else {
        dispatch(
          quotationActions.setQuotation({
            data: {
              ...quotation,
              trip: newTrip,
            },
          }),
        )
        setWidgetSkin({ ...widgetRules.getSkin(newTrip, quotation, models, context, mode) })
      }
    }
  }

  let widgetOpen =
    location.pathname == '/' ||
    _.startsWith(location.pathname, '/experience/') ||
    (_.startsWith(location.pathname, '/bookings/') && quotation.phase == 'searchresult')

  let widgetLocked =
    location.pathname == '/' ||
    _.startsWith(location.pathname, '/experience/') ||
    _.startsWith(location.pathname, '/bookings/searchresult')

  if (
    _.startsWith(location.pathname, '/bookings/') &&
    quotation.split &&
    quotation.splitDateSelected < 2
  ) {
    widgetOpen = true
    widgetLocked = true
  }

  widgetOpen = _.isEmpty(quotation.trips[quotation.trip].res)
  widgetLocked = !_.isEmpty(quotation.trips[quotation.trip].res)

  return (
    <div style={{ background: widgetSkin.bgColorLight }}>
      {quotation.split && _.startsWith(location.pathname, '/bookings/') ? (
        <BookingSplitTitleBar
          bgColor={widgetSkin.bgColorLight}
          widgetOpen={widgetOpen}
          widgetLocked={widgetLocked}
          titleOne={'Trip 1'}
          titleTwo={'Trip 2'}
          trip={quotation.trip}
          selectTrip={selectTrip}
          carOneSelected={!_.isEmpty(quotation.trips[1].car)}
          carTwoSelected={!_.isEmpty(quotation.trips[2].car)}
          tripOnePaid={!_.isEmpty(quotation.trips[1].res)}
          tripTwoPaid={!_.isEmpty(quotation.trips[2].res)}
        ></BookingSplitTitleBar>
      ) : (
        <BookingTitleBar
          bgColor={widgetSkin.bgColorLight}
          widgetOpen={widgetOpen}
          widgetLocked={widgetLocked}
        >
          <>
            {widgetSkin.header}{' '}
            {Boolean(widgetSkin.login) && Boolean(localStorage.getItem('partner-token')) ? (
              <button
                className={classes.button}
                style={{ marginLeft: 7 }}
                onClick={() => {
                  localStorage.removeItem('partner-token')
                  location.reload()
                }}
              >
                Logout
              </button>
            ) : null}
          </>
        </BookingTitleBar>
      )}
      {widgetSkin.login && localStorage.getItem('partner-token') === null ? (
        <div
          style={{
            paddingTop: 30,
            paddingBottom: 30,
            color: 'white',
            backgroundColor: widgetSkin.bgColor,
          }}
        >
          <div className={classes.authSection}>
            <form onSubmit={handleLoginSubmit} className={classes.formContainer}>
              <div>
                <div className={classes.label}>Username:</div>
                <div>
                  <input required className={classes.input} type="text" name="username" />
                </div>
              </div>
              <div>
                <div className={classes.label}>Password:</div>
                <div>
                  <input required className={classes.input} type="password" name="password" />
                </div>
              </div>
              <div>
                <div>
                  <button type="submit" className={classes.button}>
                    LOGIN
                  </button>
                </div>
              </div>
            </form>
            <div>
              <div className={classes.label}>Sign up for Travel Partners</div>
              <div className={classes.centerondesktop}>
                <a className={classes.button} href="/travel-registration">
                  SIGN UP NOW
                </a>
              </div>
            </div>
          </div>
        </div>
      ) : (
        <BookingWidget
          bgColor={widgetSkin.bgColor}
          widgetOpen={widgetOpen}
          widgetLocked={widgetLocked}
        >
          <BookingColumn minWidth="200px" maxWidth="213px" marginRight="50px">
            <BookingWidgetTitle>
              {Object.keys(itineraryLbls).length !== 0 ? itineraryLbls.pickup_location : ''}
            </BookingWidgetTitle>
            <LocationSelect
              name="formPickupLocation"
              pickupLocation={pickupLocation}
              pickupOptions={pickupOptions}
              selectHandleChange={selectHandleChange}
              selectHandleInputChange={selectHandleInputChange}
              isDisabled={!widgetSkin.pickupLocation}
              isLoading={false}
            />
            {widgetSkin.returnLocationToggle ? (
              <BookingPickupAccordion toggleDropoffLocation={toggleDropoffLocation}>
                <BookingWidgetTitle>
                  {Object.keys(itineraryLbls).length !== 0 ? itineraryLbls.dropoff_location : ''}
                </BookingWidgetTitle>
                <LocationSelect
                  name="formDropoffLocation"
                  pickupLocation={dropoffLocation}
                  pickupOptions={dropoffOptions}
                  selectHandleChange={selectHandleChange}
                  selectHandleInputChange={selectHandleInputChange}
                  isDisabled={!widgetSkin.returnLocation}
                  isLoading={false}
                />
              </BookingPickupAccordion>
            ) : (
              <React.Fragment>
                <BookingWidgetTitle>
                  {Object.keys(itineraryLbls).length !== 0 ? itineraryLbls.dropoff_location : ''}
                </BookingWidgetTitle>
                <LocationSelect
                  name="formDropoffLocation"
                  pickupLocation={dropoffLocation}
                  pickupOptions={dropoffOptions}
                  selectHandleChange={selectHandleChange}
                  selectHandleInputChange={selectHandleInputChange}
                  isDisabled={!widgetSkin.returnLocation}
                  isLoading={false}
                />
              </React.Fragment>
            )}
          </BookingColumn>

          <BookingColumn minWidth="200px" maxWidth="263px" marginRight="50px">
            <BookingWidgetTitle>
              {Object.keys(itineraryLbls).length !== 0 ? itineraryLbls.pickup_date : ''}
            </BookingWidgetTitle>
            <DateTimeSelect
              filterDate={filterDate}
              name="formPickupDateTime"
              date={pickupDate}
              onDateChange={onPickupDateChange}
              minDate={pickupMinDate}
              minTime={setHours(
                setMinutes(new Date(), globalOpeningTime.min),
                globalOpeningTime.hour,
              )}
              maxTime={setHours(
                setMinutes(new Date(), globalClosingTime.min),
                globalClosingTime.hour,
              )}
            />
          </BookingColumn>

          <BookingColumn minWidth="200px" maxWidth="263px" marginRight="50px">
            <BookingWidgetTitle>
              {Object.keys(itineraryLbls).length !== 0 ? itineraryLbls.dropoff_date : ''}
            </BookingWidgetTitle>
            <DateTimeSelect
              filterDate={filterDateDropOff ? filterDateDropOff : filterDate}
              name="formPickupDateTime"
              date={dropoffDate}
              onDateChange={onDropoffDateChange}
              minDate={dropoffMinDate}
              minTime={setHours(
                setMinutes(new Date(), globalDropOffOpeningTime.min),
                globalDropOffOpeningTime.hour,
              )}
              maxTime={setHours(
                setMinutes(new Date(), globalDropOffClosingTime.min),
                globalDropOffClosingTime.hour,
              )}
            />
          </BookingColumn>

          <BookingColumn minWidth="150px" maxWidth="152px" marginRight="50px">
            <BookingWidgetTitle>
              {Object.keys(itineraryLbls).length !== 0 ? itineraryLbls.driver_age : ''}
            </BookingWidgetTitle>
            <AgeSelect
              name="formMinimumAge"
              driverAge={driverAge}
              driveAgeOptions={driveAgeOptions}
              selectHandleChange={selectHandleChange}
              selectHandleInputChange={selectHandleInputChange}
              isDisabled={!widgetSkin.age}
              isLoading={false}
            />
          </BookingColumn>

          <BookingColumn minWidth="150px" maxWidth="175px" marginRight="50px">
            <BookingWidgetTitle disabled={!widgetSkin.promocode}>
              {Object.keys(itineraryLbls).length !== 0 ? itineraryLbls.promocode : ''}
            </BookingWidgetTitle>
            <BookingFormInput
              name="formPromoCode"
              type="text"
              placeholder={
                Object.keys(itineraryLbls).length !== 0 ? itineraryLbls.promocode_placeholder : ''
              }
              label={''}
              promoChange={promoChange}
              promo={promo}
              disabled={!widgetSkin.promocode}
            />
          </BookingColumn>

          <BookingColumn minWidth="117px" maxWidth="117px">
            {app.worker.getRates == 'ready' ? (
              <BookingSeachButton onClick={onSearch} disabled={false}>
                {Object.keys(itineraryLbls).length !== 0 ? itineraryLbls.search : ''}
              </BookingSeachButton>
            ) : (
              <BookingSeachButton onClick={void 0} disabled={true}>
                Loading
              </BookingSeachButton>
            )}
          </BookingColumn>
        </BookingWidget>
      )}
    </div>
  )
}

export default Itinerary
